import { render } from "./ProjectCard.vue?vue&type=template&id=6f56f1e4&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=6f56f1e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f56f1e4"]])

export default __exports__